import { Anchor } from '@components/atoms/Anchor';
import CheckBox from '@components/atoms/CheckBox';
import FormField from '@components/atoms/FormField';
import Spacing from '@components/atoms/Spacing';
import TextField from '@components/atoms/TextField';
import { LightParagraph } from '@components/atoms/Typography';
import OnboardingButtonBar from '@components/molecules/button-bar/OnboardingButtonBar';
import ROUTES from '@lib/constants/routes';
import { ContactFormResult, QuoteInitialForm } from '@lib/data/typesQuestions';
import { isValidPhone, validateEmail } from '@lib/helpers/misc';
import { partnerConfig } from '@lib/helpers/partner';
import GridBox from 'components/atoms/GridBox';
import React, { FC, useState } from 'react';
import { useForm } from 'react-hook-form';

interface FormResult {
  email: string;
  tel: string;
}

interface Props {
  onSubmit: (data: ContactFormResult) => void;
  loading: boolean;
  item: QuoteInitialForm;
}

const ContactForm: FC<Props> = ({ onSubmit, loading, item }) => {
  const { register, handleSubmit, errors } = useForm<FormResult>({
    mode: 'onChange',
  });

  const buttonLabel = partnerConfig?.config?.askForContactFirst
    ? 'Continuar'
    : 'Finalizar';

  const [terms, setTerms] = useState(false);

  return (
    <form
      onSubmit={handleSubmit((data) => {
        onSubmit({ email: data.email, phoneNumber: data.tel });
      })}
    >
      <GridBox justifyContent="center" flexDirection="column">
        <Spacing bottom={1}>
          <LightParagraph fontSize={14} center>
            Nós usamos essas informações para entrar em contato com você
          </LightParagraph>
        </Spacing>
        <GridBox>
          <GridBox justifyContent="center" width={[1, 0.45, 0.45]}>
            <FormField style={{ width: '100%' }}>
              <TextField
                type="email"
                name="email"
                autoComplete="email"
                placeholder="Email"
                defaultValue={item.email || ''}
                inputRef={register({
                  required: 'Aqui precisamos de um email',
                  validate: {
                    valid: (s) =>
                      validateEmail(s) || 'Precisamos de um email válido',
                  },
                })}
                errorMessage={errors?.email?.message}
              />
            </FormField>
          </GridBox>
          <GridBox justifyContent="center" width={[1, 0.45, 0.45]}>
            <FormField style={{ width: '100%' }}>
              <TextField
                defaultValue={item.phoneNumber || ''}
                placeholder="Número do Celular"
                inputRef={register({
                  required: 'Precisamos de um número',
                  validate: {
                    valid: (phone) =>
                      isValidPhone(phone) || 'Precisamos de um número válido',
                  },
                })}
                type="tel"
                autoComplete="tel tel-national"
                errorMessage={errors?.tel?.message}
                name="tel"
                mask={[
                  '(',
                  /\d/,
                  /\d/,
                  ')',
                  ' ',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  '-',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
              />
            </FormField>
          </GridBox>
          <GridBox justifyContent="center" width={[1, 1, 1]} mt={[16]}>
            <CheckBox
              label="Estou ciente e concordo que os dados fornecidos poderão ser compartilhados com corretores de seguros parceiros, incluindo para fins de oferecimento de cotações de seguros"
              name="terms"
              onChange={setTerms}
              checked={terms}
            />
          </GridBox>
        </GridBox>
      </GridBox>
      <OnboardingButtonBar
        text={buttonLabel}
        loading={loading}
        disabled={!terms}
      />

      <LightParagraph fontSize={14} center>
        Ao clicar em &quot;{buttonLabel}&quot;, você concorda com a{' '}
        <Anchor target="_blank" href={ROUTES.privacy}>
          Política de Privacidade
        </Anchor>{' '}
        e os{' '}
        <Anchor target="_blank" href={ROUTES.terms}>
          Termos de Uso
        </Anchor>{' '}
        da Luna.
      </LightParagraph>
    </form>
  );
};

export default ContactForm;
